export const initialState = {
  unitList: [],
  taskList: [],
};
